/**
 * created by lei lei
 *上下左右，垂直居中组件
 * style={{height:200}}跟正常style一样
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class VerticalCenter extends Component {
    static defaultProps = {
        style:{}
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className={'VerticalCenter'}
                 style={{display: 'flex', width: '100%',...this.props.style}}>
                <div style={{margin: 'auto'}}>
                    {React.Children.map(this.props.children, child => child)}
                </div>
            </div>
        )
    }

}